import {useEffect} from 'react'
import {useDispatch} from 'react-redux'
import {cleanSuccessMessage} from '../../redux/slices/messageSlice'

/**
 * Hook personalizado para limpiar automáticamente los mensajes de éxito.
 *
 * Utiliza el hook `useDispatch` de Redux para despachar una acción que limpia los mensajes de éxito
 * del store. La limpieza se realiza después de 5 segundos mediante el uso de `setTimeout`.
 *
 * Este hook es utilizado en todos los componentes List donde se desea mostrar los mensajes de éxito
 * o error temporalmente y asegurarse de que se limpien automáticamente después.
 *
 * @example
 * useCleanSuccessMessageHook();
 * // Después de 5 segundos, se despachará la acción `cleanSuccessMessage` para limpiar los mensajes de éxito.
 */

export const useCleanSuccessMessageHook = () => {
  const dispatch = useDispatch()

  useEffect(() => {
    const timer = setTimeout(() => {
      dispatch(cleanSuccessMessage())
    }, 5000)

    return () => {
      clearTimeout(timer)
    }
  }, [])
}
